import styles from "./Footer.module.scss";
export const Footer = () => {
  return <div className={styles.footer}></div>;
};
